import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Row, Col } from 'core/components/ui'
import SVG from 'core/components/svg'
import { font, greys, fontFamily } from 'assets/themes/theme-default'

const ListInfosRow = styled(Row)`
  font-size: ${font.size.xs};
  line-height: ${font.size.xs};
  padding: 5px 0;
  align-items: center;
`

const ColValueWrapper = styled(Col)`
  font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.bold.name},`}
    ${fontFamily.bold};
  text-align: left;
`
const ColIconWrapper = styled(Col)`
  text-align: right;
`

const Icon = styled(SVG)`
  width: 24px;
  height: 24px;
  fill: ${greys.dark1};
  vertical-align: middle;
`

const renderRow = props => {
  const { value, icon } = props

  return (
    <ListInfosRow type="flex" gutter={20}>
      <ColIconWrapper span={6}>
        <Icon svg={icon} />
      </ColIconWrapper>
      <ColValueWrapper span={18}>{value}</ColValueWrapper>
    </ListInfosRow>
  )
}

renderRow.propTypes = {
  value: PropTypes.string.isRequired,
  icon: PropTypes.shape().isRequired
}

export default renderRow
